import React, { useState, useEffect } from "react";
import Constants from "../components/Constant.js";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  Grid,
  Autocomplete,
  Snackbar,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import MainLayout from "../components/MainLayout.js";
import backgroundImage from "../assets/backgroundHome.png";

export default function EditarCartao() {
  const [prefeituras, setPrefeituras] = useState([]);
  const [filteredPrefeituras, setFilteredPrefeituras] = useState([]);
  const [selectedPrefeitura, setSelectedPrefeitura] = useState(null);
  const [searchPrefeitura, setSearchPrefeitura] = useState("");
  const [cartoes, setCartoes] = useState([]);
  const [filteredCartoes, setFilteredCartoes] = useState([]);
  const [selectedCartao, setSelectedCartao] = useState(null);
  const [searchCartao, setSearchCartao] = useState("");
  const [orgaos, setOrgaos] = useState([]);
  const [formData, setFormData] = useState({
    orgao: "",
    senha: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  useEffect(() => {
    const fetchPrefeituras = async () => {
      try {
        const response = await fetch(Constants.API_CONSULTAR_PREFEITURA, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (response.ok) {
          setPrefeituras(data.prefeituras);
          setFilteredPrefeituras(data.prefeituras);
        } else {
          showSnackbar("Erro ao buscar prefeituras.", "error");
        }
      } catch (error) {
        console.error("Erro ao conectar com o servidor:", error);
        showSnackbar("Erro ao conectar com o servidor.", "error");
      }
    };
    fetchPrefeituras();
  }, [token]);

  useEffect(() => {
    if (searchPrefeitura) {
      const filtered = prefeituras.filter((prefeitura) =>
        prefeitura.PRE_NOME.toLowerCase().includes(searchPrefeitura.toLowerCase())
      );
      setFilteredPrefeituras(filtered);
    } else {
      setFilteredPrefeituras(prefeituras);
    }
  }, [searchPrefeitura, prefeituras]);

  useEffect(() => {
    const fetchCartoes = async () => {
      if (!selectedPrefeitura) {
        setCartoes([]);
        setFilteredCartoes([]);
        return;
      }

      try {
        const response = await fetch(`${Constants.API_BASE_URL}/api/listarPrefeitura/${selectedPrefeitura.PRE_ID}`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (response.ok && data.status) {
          setCartoes(data.prefeitura.cartoes);
          setFilteredCartoes(data.prefeitura.cartoes);
        } else {
          showSnackbar("Erro ao buscar cartões.", "error");
        }
      } catch (error) {
        console.error("Erro ao conectar com o servidor:", error);
        showSnackbar("Erro ao conectar com o servidor.", "error");
      }
    };

    const fetchOrgaos = async () => {
      if (!selectedPrefeitura) {
        setOrgaos([]);
        return;
      }

      try {
        const response = await fetch(`${Constants.API_BASE_URL}/api/orgaosPrefeitura/${selectedPrefeitura.PRE_ID}`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (response.ok) {
          let orgaosArray = [];
          if (data.orgaos) {
            orgaosArray = Object.values(data.orgaos);
          } else if (Array.isArray(data)) {
            orgaosArray = data;
          } else if (data.data && Array.isArray(data.data)) {
            orgaosArray = data.data;
          }
          setOrgaos(orgaosArray);
        } else {
          showSnackbar("Erro ao buscar órgãos.", "error");
        }
      } catch (error) {
        console.error("Erro ao buscar órgãos:", error);
        showSnackbar("Erro ao buscar órgãos.", "error");
      }
    };

    fetchCartoes();
    fetchOrgaos();
  }, [selectedPrefeitura, token]);

  useEffect(() => {
    if (searchCartao) {
      const filtered = cartoes.filter((cartao) =>
        cartao.CAR_ID.toString().toLowerCase().includes(searchCartao.toLowerCase()) ||
        (cartao.CAR_RESP_NOME && cartao.CAR_RESP_NOME.toLowerCase().includes(searchCartao.toLowerCase()))
      );
      setFilteredCartoes(filtered);
    } else {
      setFilteredCartoes(cartoes);
    }
  }, [searchCartao, cartoes]);

  useEffect(() => {
    if (selectedCartao) {
      setFormData({
        orgao: selectedCartao.CAR_ID_ORGAO_RESP || "",
        senha: selectedCartao.CAR_SENHA || "",
      });
    }
  }, [selectedCartao]);

  const handlePrefeituraChange = (_, newValue) => {
    setSelectedPrefeitura(newValue);
    setSelectedCartao(null);
    setFormData({
      orgao: "",
      senha: "",
    });
    setErrors({});
  };

  const handleCartaoChange = (_, newValue) => {
    setSelectedCartao(newValue);
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.orgao) {
      newErrors.orgao = "Órgão é obrigatório";
    }
    if (!formData.senha) {
      newErrors.senha = "Senha é obrigatória";
    } else if (formData.senha.length < 4) {
      newErrors.senha = "Senha deve ter pelo menos 4 caracteres";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!selectedCartao) {
      showSnackbar("Selecione um cartão para editar.", "error");
      return;
    }

    if (!validateForm()) {
      showSnackbar("Por favor, corrija os erros no formulário.", "error");
      return;
    }

    try {
      const response = await fetch(`${Constants.API_BASE_URL}/api/cartao/${selectedCartao.CAR_ID}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          CAR_ID_ORGAO_RESP: formData.orgao,
          CAR_SENHA: formData.senha,
          CAR_TIPO: selectedCartao.CAR_TIPO
        }),
      });

      if (response.ok) {
        showSnackbar("Cartão atualizado com sucesso!", "success");
        // Atualiza a lista de cartões
        const updatedCartoes = cartoes.map(cartao => 
          cartao.CAR_ID === selectedCartao.CAR_ID 
            ? { 
                ...cartao, 
                CAR_ID_ORGAO_RESP: formData.orgao,
                CAR_SENHA: formData.senha
              }
            : cartao
        );
        setCartoes(updatedCartoes);
        setFilteredCartoes(updatedCartoes);
        
        // Limpa os campos após salvar
        setSelectedCartao(null);
        setFormData({
          orgao: "",
          senha: "",
        });
        setErrors({});
      } else {
        const data = await response.json();
        showSnackbar(data.message || "Erro ao atualizar cartão.", "error");
      }
    } catch (error) {
      console.error("Erro ao conectar com o servidor:", error);
      showSnackbar("Erro ao conectar com o servidor.", "error");
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <MainLayout>
      <Box
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          backgroundBlendMode: "overlay",
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ p: { xs: 2, sm: 4 }, bgcolor: "background.paper", borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>
              Editar Cartão
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Autocomplete
                  options={filteredPrefeituras}
                  getOptionLabel={(option) => 
                    option ? option.PRE_NOME || '' : ""
                  }
                  value={selectedPrefeitura}
                  onChange={handlePrefeituraChange}
                  onInputChange={(_, newInputValue) => {
                    setSearchPrefeitura(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecione uma Prefeitura"
                      fullWidth
                      margin="normal"
                      size="medium"
                      helperText="Selecione uma prefeitura para continuar"
                      sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {option.PRE_NOME}
                    </li>
                  )}
                />
              </Grid>

              {selectedPrefeitura && (
                <>
                  <Grid item xs={12}>
                    <Autocomplete
                      options={filteredCartoes}
                      getOptionLabel={(option) => 
                        option ? `Cartão ${option.CAR_ID} - ${option.CAR_RESP_NOME || 'Sem responsável'} (${option.CAR_TIPO || 'COMUM'})` : ""
                      }
                      value={selectedCartao}
                      onChange={handleCartaoChange}
                      onInputChange={(_, newInputValue) => {
                        setSearchCartao(newInputValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione um Cartão"
                          fullWidth
                          margin="normal"
                          size="medium"
                          helperText="Selecione um cartão para editar"
                          sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <strong>Cartão {option.CAR_ID}</strong> - {option.CAR_RESP_NOME || 'Sem responsável'} ({option.CAR_TIPO || 'COMUM'})
                        </li>
                      )}
                    />
                  </Grid>

                  {selectedCartao && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          options={orgaos}
                          getOptionLabel={(option) => 
                            option ? `${option.ORG_SIGLA} - ${option.ORG_DESCRICAO}` : ""
                          }
                          value={orgaos.find(orgao => orgao.ORG_ID === formData.orgao) || null}
                          onChange={(_, newValue) => {
                            handleInputChange({
                              target: {
                                name: "orgao",
                                value: newValue ? newValue.ORG_ID : ""
                              }
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Órgão *"
                              fullWidth
                              margin="normal"
                              size="medium"
                              error={!!errors.orgao}
                              helperText={errors.orgao}
                              sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                            />
                          )}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <strong>{option.ORG_SIGLA}</strong> - {option.ORG_DESCRICAO}
                            </li>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Senha *"
                          name="senha"
                          type="password"
                          value={formData.senha}
                          onChange={handleInputChange}
                          error={!!errors.senha}
                          helperText={errors.senha}
                          margin="normal"
                          size="medium"
                          sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                          inputProps={{ maxLength: 20 }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            sx={{ height: "56px", width: "200px" }}
                          >
                            Salvar Alterações
                          </Button>
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Box>
        </Container>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </MainLayout>
  );
}
